const state = {
  list: [],
  pagination: [],
  formSend: false,
  reloadList: false,
  options: {},
};

export default state;
